import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';
import { Room } from '@breakroom-nx/classes';

interface ChatsState {
  selectedRoom?: Room;
}

const initialState: ChatsState = {
  selectedRoom: undefined,
};

export const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    selectRoom: (state, action: PayloadAction<any>) => {
      const room: Room = action.payload;
      // console.log(`Selected Room: ${room.title}`);
      state.selectedRoom = room;
    },
    deselectRoom: (state) => {
      state.selectedRoom = undefined;
    },
  },
});

export const { selectRoom, deselectRoom } = chatsSlice.actions;
export const getSelectedRoom = (state: RootState) => state.chats.selectedRoom;
export default chatsSlice.reducer;
